import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl } from "../comman/config"; // Adjust path based on your project structure
import * as XLSX from 'xlsx';

const PurchaseDetailModal = ({ showModal, setShowModal, selectedItem, onSave, onClose }) => {
  const [packRows, setPackRows] = useState([]);
  const [totals, setTotals] = useState({
    totalPack: 0,
    totalPurchaseQty: 0,
    avgRate: 0,
    totalValue: 0
  });
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (selectedItem && showModal) {
      // Initialize with packDetails if available, otherwise create from sequences
      if (selectedItem.packDetails && selectedItem.packDetails.length > 0) {
        setPackRows(selectedItem.packDetails);
      } else if (selectedItem.sequences && selectedItem.sequences.length > 0) {
        // Convert sequences to packDetails format
        const convertedRows = selectedItem.sequences.map(seq => ({
          pack: seq.sequence_number || 0,
          purchaseQty: seq.quantity || 0,
          rate: seq.rate || 0,
          value: seq.value || 0
        }));
        setPackRows(convertedRows);
      } else {
        // Default empty row
        setPackRows([{ 
          pack: 0, 
          purchaseQty: 0, 
          rate: 0, 
          value: 0 
        }]);
      }
    }
  }, [selectedItem, showModal]);

  useEffect(() => {
    console.log("pack rows:",packRows.length)
    // Calculate totals whenever rows change
    if (packRows.length > 0) {
      const avg = packRows.length
      const totalPack = packRows.reduce((acc, row) => acc + parseInt(row.pack || 0), 0);
      const totalPurchaseQty = packRows.reduce((acc, row) => acc + parseFloat(row.purchaseQty || 0), 0);
      const totalRate = packRows.reduce((acc, row) => acc + parseFloat(row.rate || 0), 0);
      const totalValue = packRows.reduce((acc, row) => acc + parseFloat(row.value || 0), 0);
      console.log("total value:",totalValue)
      const avgRate = totalPurchaseQty > 0 ? (totalRate / avg) : 0;
      
      setTotals({
        totalPack,
        totalPurchaseQty,
        avgRate: avgRate.toFixed(2),
        totalValue
      });
    }
  }, [packRows]);

  // const handleInputChange = (index, field, value) => {
  //   const updatedRows = [...packRows];
    
  //   // Update the specified field
  //   updatedRows[index][field] = value;
    
  //   // If changing pack or purchaseQty or rate, recalculate value
  //   if (field === 'pack' || field === 'purchaseQty' || field === 'rate') {
  //     const purchaseQty = parseFloat(updatedRows[index].purchaseQty || 0);
  //     const rate = parseFloat(updatedRows[index].rate || 0);
  //     updatedRows[index].value = (purchaseQty * rate).toFixed(2);
  //   }
    
  //   setPackRows(updatedRows);
  // };
  const handleInputChange = (index, field, value) => {
    const updatedRows = [...packRows];

    // Update the specified field
    updatedRows[index][field] = value;

    // Calculate rate based on purchaseQty and value (payment)
    if (field === 'purchaseQty' || field === 'value') {
      const purchaseQty = parseFloat(updatedRows[index].purchaseQty || 0);
      const payment = parseFloat(updatedRows[index].value || 0);

      // Calculate rate per kg: rate = payment / quantity
      if (purchaseQty > 0) {
        updatedRows[index].rate = (payment / purchaseQty).toFixed(2);
      } else {
        updatedRows[index].rate = 0;
      }
    }

    // If pack is changed, just update it (no calculation needed)
    // If rate is changed directly (though it should be read-only), recalculate value
    if (field === 'rate') {
      const purchaseQty = parseFloat(updatedRows[index].purchaseQty || 0);
      const rate = parseFloat(updatedRows[index].rate || 0);
      updatedRows[index].value = (purchaseQty * rate).toFixed(2);
    }

    setPackRows(updatedRows);
  };

  const handleAddRow = () => {
    setPackRows([...packRows, { pack: 0, purchaseQty: 0, rate: 0, value: 0 }]);
  };

  const handleRemoveRow = (index) => {
    if (window.confirm("Are you sure you want to remove this row?")) {
      const updatedRows = [...packRows];
      updatedRows.splice(index, 1);
      setPackRows(updatedRows);
    }
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);

    //   // Validate that purchaseQty and rate in each row are > 0
    // const invalidRow = packRows.find(
    //   (row) => parseFloat(row.purchaseQty) <= 0 || parseFloat(row.rate) <= 0
    // );

      // Validate that purchaseQty and value (payment) in each row are > 0
      const invalidRow = packRows.find(
        (row) => parseFloat(row.purchaseQty) <= 0 || parseFloat(row.value) <= 0
      );

    if (invalidRow) {
      alert("Each row must have a Purchase Qty and Rate greater than 0.");
      setIsSaving(false);
      return;
    }
      
      // Convert packRows to sequences format
      const sequences = packRows.map((row, index) => ({
        sequence_number: parseFloat(row.pack || 0),
        quantity: parseFloat(row.purchaseQty || 0),
        rate: parseFloat(row.rate || 0),
        value: parseFloat(row.value || 0)
      }));
      
      // Prepare data to save
      const dataToSave = {
        item_requirement_id: selectedItem.id,
        purchase_qty: totals.totalPurchaseQty,
        pur_pack_nos: totals.totalPack,
        avg_rate: totals.avgRate,
        total_value: totals.totalValue,
        sequences: sequences
      };
      
      // Make API call to save the data
      const response = await axios.post(`${baseUrl}/purchase/modal_save`, dataToSave);
      
      if (response.data.status) {
        // Update the local state
        const updatedItem = {
          ...selectedItem,
          packDetails: packRows,
          purchase_qty: totals.totalPurchaseQty,
          pur_pack_nos: totals.totalPack,
          avg_rate: totals.avgRate,
          total_value: totals.totalValue
        };
        
        // Call the parent component's onSave function
        onSave(updatedItem);
        setShowModal(false);
      } else {
        alert("Failed to save data: " + response.data.msg);
      }
    } catch (error) {
      console.error("Error saving purchase details:", error);
      alert("An error occurred while saving. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  const handleClose = () => {
    onClose();
    setShowModal(false);
  };

  // Excel export function
const exportToExcel = () => {
  if (!selectedItem || !packRows.length) return;
  
  // Prepare data
  const data = packRows.map((row) => ({
    'Pack': row.pack || 0,
    'Purchase Qty': row.purchaseQty || 0,
    'Rate': row.rate || 0,
    'Value': row.value || 0
  }));
  
  // Add totals row with label
  data.push({
    'Pack': `Total: ${totals.totalPack}`,
    'Purchase Qty': totals.totalPurchaseQty,
    'Rate': totals.avgRate,
    'Value': totals.totalValue
  });
  
  // Create worksheet
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Purchase Details");
  
  // Generate Excel file
  const fileName = `${selectedItem.ingredient || 'Item'}_PurchaseDetails.xlsx`;
  XLSX.writeFile(wb, fileName);
};

  if (!showModal) return null;

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none px-2 sm:px-0">
        <div className="relative w-full max-w-md sm:max-w-xl md:max-w-2xl lg:max-w-4xl mx-auto my-6">
          <div className="border-0 rounded-lg shadow-lg flex flex-col w-full bg-white outline-none focus:outline-none max-h-[90vh]">

            {/* Header */}
            <div className="flex items-start justify-between p-4 sm:p-5 border-b border-solid border-gray-200 rounded-t">
              <h3 className="text-base sm:text-lg font-semibold">
                Total Purchase Qty Details - {selectedItem?.ingredient}
              </h3>
              <button
                className="p-1 ml-auto bg-transparent border-0 text-black text-xl font-bold"
                onClick={handleClose}
              >
                ×
              </button>
            </div>

            {/* Body */}
            <div className="p-4 sm:p-6 flex-1 overflow-y-auto">
              <p className="font-bold mb-4">Order Qty: {selectedItem?.total_order} Kgs.</p>

              {/* Desktop Table View */}
              <div className="hidden lg:block">
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse border border-gray-300 text-sm">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="border p-2">દાગીના</th>
                        <th className="border p-2">લેવાયલ વજન (કિલો)</th>
                        <th className="border p-2">રેટ/કિલો</th>
                        <th className="border p-2">પેમેન્ટ (₹)</th>
                        <th className="border p-2" colSpan="2">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {packRows.map((row, index) => (
                        <tr key={index} className={index % 2 === 0 ? "bg-yellow-50" : "bg-gray-50"}>
                          <td className="border p-2">
                            <input
                              type="number"
                              value={row.pack || ""}
                              onChange={(e) => handleInputChange(index, 'pack', e.target.value)}
                              className="w-full p-1 border rounded text-sm"
                            />
                          </td>
                          <td className="border p-2">
                            <input
                              type="number"
                              value={row.purchaseQty || ""}
                              onChange={(e) => handleInputChange(index, 'purchaseQty', e.target.value)}
                              className="w-full p-1 border rounded text-sm"
                            />
                          </td>
                          {/* <td className="border p-2">
                            <input
                              type="number"
                              value={row.rate || ""}
                              onChange={(e) => handleInputChange(index, 'rate', e.target.value)}
                              className="w-full p-1 border rounded text-sm"
                            />
                          </td> */}
                          <td className="border p-2">
                            <input
                              type="number"
                              value={row.rate || ""}
                              readOnly
                              className="w-full p-1 border rounded text-sm bg-gray-100"
                              style={{ backgroundColor: '#f5f5f5' }}
                            />
                          </td>
                          {/* <td className="border p-2 bg-gray-200 text-sm">
                            {parseFloat(row.value || 0).toFixed(2)}
                          </td> */}
                          <td className="border p-2">
                            <input
                              type="number"
                              value={row.value || ""}
                              onChange={(e) => handleInputChange(index, 'value', e.target.value)}
                              className="w-full p-1 border rounded text-sm"
                              placeholder="Enter payment"
                            />
                          </td>
                          <td className="border p-2">
                            <button
                              onClick={handleAddRow}
                              className="bg-blue-400 text-white px-2 py-1 rounded text-sm w-full sm:w-auto"
                            >
                              +
                            </button>
                          </td>
                          <td className="border p-2">
                            <button
                              disabled={packRows.length === 1}
                              onClick={() => handleRemoveRow(index)}
                              className="bg-red-400 text-white px-2 py-1 rounded text-sm w-full sm:w-auto disabled:bg-red-300"
                            >
                              -
                            </button>
                          </td>
                        </tr>
                      ))}
                      <tr className="bg-gray-200 font-bold">
                        <td className="border p-2">{totals.totalPack}</td>
                        <td className="border p-2">{totals?.totalPurchaseQty ? parseFloat(totals.totalPurchaseQty).toFixed(2) : '0.00'}</td>
                        <td className="border p-2">{totals.avgRate}</td>
                        <td className="border p-2">{totals.totalValue}</td>
                        <td className="border p-2" colSpan="2"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Mobile Card View */}
              <div className="block lg:hidden">
                <div className="space-y-4">
                  {packRows.map((row, index) => (
                    <div key={index} className={`border rounded-lg p-4 ${index % 2 === 0 ? "bg-yellow-50" : "bg-gray-50"}`}>
                      {/* Card Header */}
                      <div className="flex justify-between items-center mb-3">
                        <h4 className="font-semibold text-gray-700">દાગીના #{index + 1}</h4>
                        <div className="flex gap-2">
                          <button
                            onClick={handleAddRow}
                            className="bg-blue-400 text-white px-3 py-1 rounded text-sm flex items-center justify-center w-8 h-8"
                          >
                            +
                          </button>
                          <button
                            disabled={packRows.length === 1}
                            onClick={() => handleRemoveRow(index)}
                            className="bg-red-400 text-white px-3 py-1 rounded text-sm flex items-center justify-center w-8 h-8 disabled:bg-red-300"
                          >
                            -
                          </button>
                        </div>
                      </div>

                      {/* Input Fields */}
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        <div>
                          <label className="block text-xs font-medium text-gray-600 mb-1">દાગીના</label>
                          <input
                            type="number"
                            value={row.pack || ""}
                            onChange={(e) => handleInputChange(index, 'pack', e.target.value)}
                            className="w-full p-2 border rounded text-sm"
                            placeholder="Enter pack"
                          />
                        </div>

                        <div>
                          <label className="block text-xs font-medium text-gray-600 mb-1">લેવાયલ વજન (કિલો)</label>
                          <input
                            type="number"
                            value={row.purchaseQty || ""}
                            onChange={(e) => handleInputChange(index, 'purchaseQty', e.target.value)}
                            className="w-full p-2 border rounded text-sm"
                            placeholder="Enter quantity"
                          />
                        </div>

                        {/* <div>
                          <label className="block text-xs font-medium text-gray-600 mb-1">રેટ/કિલો</label>
                          <input
                            type="number"
                            value={row.rate || ""}
                            onChange={(e) => handleInputChange(index, 'rate', e.target.value)}
                            className="w-full p-2 border rounded text-sm"
                            placeholder="Enter rate"
                          />
                        </div> */}
                        <div>
                          <label className="block text-xs font-medium text-gray-600 mb-1">રેટ/કિલો</label>
                          <div className="w-full p-2 bg-gray-100 border rounded text-sm font-medium">
                            {parseFloat(row.rate || 0).toFixed(2)}
                          </div>
                        </div>

                        {/* <div>
                          <label className="block text-xs font-medium text-gray-600 mb-1">પેમેન્ટ (₹)</label>
                          <div className="w-full p-2 bg-gray-200 border rounded text-sm font-medium">
                            {parseFloat(row.value || 0).toFixed(2)}
                          </div>
                        </div> */}
                        <div>
                          <label className="block text-xs font-medium text-gray-600 mb-1">પેમેન્ટ (₹)</label>
                          <input
                            type="number"
                            value={row.value || ""}
                            onChange={(e) => handleInputChange(index, 'value', e.target.value)}
                            className="w-full p-2 border rounded text-sm"
                            placeholder="Enter payment"
                          />
                        </div>
                      </div>
                    </div>
                  ))}

                  {/* Mobile Totals Card */}
                  <div className="bg-gray-200 border rounded-lg p-4 font-bold">
                    <h4 className="font-semibold text-gray-700 mb-3">ટોટલ</h4>
                    <div className="grid grid-cols-2 gap-3 text-sm">
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">ટોટલ દાગીના</label>
                        <div className="p-2 bg-white border rounded">
                          {totals.totalPack}
                        </div>
                      </div>

                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">ટોટલ લેવાયલ વજન (કિલો)</label>
                        <div className="p-2 bg-white border rounded">
                          {totals?.totalPurchaseQty ? parseFloat(totals.totalPurchaseQty).toFixed(2) : '0.00'}
                        </div>
                      </div>

                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">રેટ/કિલો</label>
                        <div className="p-2 bg-white border rounded">
                          {totals.avgRate}
                        </div>
                      </div>

                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">ટોટલ પેમેન્ટ (₹)</label>
                        <div className="p-2 bg-white border rounded">
                          {totals.totalValue}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="flex flex-col sm:flex-row items-center justify-end gap-2 sm:gap-4 p-4 sm:p-6 border-t border-solid border-gray-200 rounded-b">
              <button
                className="bg-blue-400 text-white font-bold uppercase px-4 py-2 text-sm rounded shadow hover:shadow-lg w-full sm:w-auto"
                type="button"
                onClick={exportToExcel}
              >
                Export Excel
              </button>
              <button
                className="bg-blue-400 text-white font-bold uppercase px-4 py-2 text-sm rounded shadow hover:shadow-lg w-full sm:w-auto"
                type="button"
                onClick={handleClose}
              >
                Close
              </button>
              <button
                className="bg-blue-400 text-white font-bold uppercase px-4 py-2 text-sm rounded shadow hover:shadow-lg disabled:bg-blue-300 w-full sm:w-auto"
                type="button"
                onClick={handleSave}
                disabled={isSaving}
              >
                {isSaving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};

export default PurchaseDetailModal;